/* eslint-disable max-len */
const React = require('react');

const HomeFooterGitHub = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd" stroke="#323232" strokeWidth="1.2">
      <g>
        <path d="M6 .389c.822 0 1.644.13 2.466.389l.19-.12C9.337.228 10.126 0 10.932 0h0c.11.519.164.907.164 1.167 0 .777-.164 1.011-.164 1.166C10.932 2.723 12 3.5 12 5.444c0 2.14-1.057 2.957-2.301 3.5-.745.325-2.207.098-1.899.39.264.249.666.777.666 1.555 0 .518.011 1.722.034 3.611M6 .389c-.822 0-1.644.13-2.466.389l-.19-.12C2.663.228 1.874 0 1.068 0h0C.958.519.904.907.904 1.167c0 .777.164 1.011.164 1.166C1.068 2.723 0 3.5 0 5.444c0 2.14 1.057 2.957 2.301 3.5.745.325 2.207.098 1.899.39-.264.249-.666.777-.666 1.555 0 .518-.011 1.722-.034 3.611" transform="translate(3.9 4.5)" />
        <path strokeLinecap="round" d="M.4 10.5c.5 0 1 .21 1.5.63.5.42 1 .482 1.5.187" transform="translate(3.9 4.5)" />
      </g>
      <circle cx="9.95" cy="9.95" r="9.25" />
    </g>
  </svg>
);

module.exports = HomeFooterGitHub;
